import * as LucideIcons from "lucide-react";
import { useAuthedSrc } from "./authedMedia";

// `src`, when given, is an uploaded icon image (served from GridFS, which now
// requires sign-in) and takes priority over the Lucide `name` fallback. If it
// 401s — an anonymous visitor — fall back to the Lucide icon instead of a
// broken-image glyph.
export function IconByName({ name, src, className = "", strokeWidth = 2.5 }) {
    // Fetched with the gateway token (an <img> can't send it); the Lucide
    // icon shows while loading and if the fetch fails (e.g. signed out).
    const { src: resolved, failed } = useAuthedSrc(src);
    if (src && resolved && !failed) {
        return <img src={resolved} alt="" className={`${className} object-contain rounded`} />;
    }
    const Comp = LucideIcons[name] || LucideIcons.Sparkles;
    return <Comp className={className} strokeWidth={strokeWidth} />;
}

// Pastel tile backgrounds (mapped to Tailwind tokens set in tailwind.config.js)
export const coverBg = {
    sky: "bg-sky",             // pastel cyan-mint  #E6FCF5
    peach: "bg-peach",         // pastel pink       #FCE6F0
    sage: "bg-pastelYellow",   // pastel butter     #FDF8E6
    cream: "bg-lavender",      // pastel lavender   #EFECFD
};

// All tiles use the deep green ink — reads well across all four pastels
export const coverInk = {
    sky: "text-deepGreen",
    peach: "text-deepGreen",
    sage: "text-deepGreen",
    cream: "text-deepGreen",
};
